import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import PasswordChangeForm from './auth/PasswordChange';
import withAuthorization from './auth/withAuthorization';
import {
  startEditUserProfile,
  startEditOrgAbout,
} from 'store/actions/account';

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    margin: theme.spacing.unit*4,
  },
  card: {
    margin: theme.spacing.unit*2,
    flexGrow: 1,
    maxWidth: "600px",
    minWidth: "300px",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
  }
});

const AccountPage = (props) => {
  const {
    classes,
    account,
    startEditUserProfile,
    startEditOrgAbout,
  } = props;


  const { user, organizations } = account;
  const profile = user ? user.profile : {};
  const organization = organizations[0] ? organizations[0] : {};
  const about = organization.about ? organization.about : {};

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardHeader title="Account Info" />
        <CardContent className={classes.cardContent}>
          <TextField
            label="Full Name"
            value={profile.username}
            onChange={event => startEditUserProfile(user.id, { username: event.target.value })}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            label="Company Name"
            value={about.name}
            onChange={event => startEditOrgAbout(organization.id, { name: event.target.value })}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            label="Email"
            value={profile.email}
            onChange={event => startEditUserProfile(user.id, { email: event.target.value })}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            label="Phone Number"
            value={about.phone}
            onChange={event => startEditOrgAbout(organization.id, { phone: event.target.value })}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </CardContent>
      </Card>

      <Card className={classes.card}>
        <CardHeader title="Reset Password" />
        <CardContent className={classes.cardContent}>
          <PasswordChangeForm />
        </CardContent>
      </Card>
    </div>
  );
}


const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser,
  account: state.accountState,
});

const mapDispatchToProps = {
  startEditUserProfile,
  startEditOrgAbout,
};

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(AccountPage);



// WEBPACK FOOTER //
// ./src/components/Account.jsx